export default __webpack_public_path__ + "static/media/google-adsimg1.eb479652.png";